import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0634038"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "flex dialog-detail justify-content-between align-items-center mt-s2" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "dialog-footer dialog-footer-two-btn" }

import Spinner from '@/components/Spinner.vue';
import { format, printUSD } from '@/utils/format';
import BigNumber from 'bignumber.js';
import { useI18n } from 'vue-i18n';
import { AutoStaking } from '@/sdk/entities/autoStaking';
import BluesTokenIcon from '@/components/token/BluesTokenIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StakeConfirmation',
  props: {
    amountUsd: null,
    amount: null,
    approve: { type: Boolean },
    inProgress: { type: Boolean },
    token: null,
    cancel: null,
    confirm: null,
    checkTimer: { type: Boolean },
    pool: null
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('yieldPool.stakeConfirmDialog.youStake')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BluesTokenIcon, {
        size: "20",
        full: ""
      }),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_unref(format)(__props.amount, 16)), 1),
        _createElementVNode("span", _hoisted_3, " / " + _toDisplayString(_unref(printUSD)(__props.amountUsd)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('yieldPool.stakeConfirmDialog.confirmBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.confirm())),
        disabled: __props.inProgress
      }, {
        default: _withCtx(() => [
          (__props.inProgress)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('yieldPool.stakeConfirmDialog.confirmBtn')), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})